module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3CJAV"))).then(() => parcelRequire('hEqeo'));